const ShimmerEffect = () => {
	return (
		<div className="space-y-2 rounded-primary p-2
		[&>div]:h-3 [&>div]:overflow-hidden [&>div]:relative [&>div]:before:absolute [&>div]:before:inset-0 [&>div]:before:-translate-x-full [&>div]:before:animate-[shimmer_1s_infinite] [&>div]:before:bg-gradient-to-r [&>div]:before:from-transparent [&>div]:before:via-grey-50 [&>div]:before:to-transparent [&>div]:before:opacity-50 [&>div]:rounded-sm [&>div]:bg-grey
	">
			<div className="w-11/12"></div>
			<div></div>
			<div></div>
			<div></div>
			<div className="w-3/4"></div>
			<div className=" w-1/4"></div>
		</div>
	)
}

export default ShimmerEffect